import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        {/* Background overlay */}
        <div className="hero-overlay"></div>
        
        {/* Arms background image */}
        <div className="hero-arms-bg"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-left">
            <motion.div 
              className="hero-stat"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <span className="stat-number">90+</span>
              <span className="stat-text">Satisfied<br />clients</span>
            </motion.div>
          </div>

          <div className="hero-center">
            <motion.div 
              className="hero-image"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <img 
                src="/images/hero/muscular_no_bg.png" 
                alt="TaaFit fitness transformation results - Professional personal training showing muscular physique achieved through personalized coaching"
                className="hero-main-image"
                loading="eager"
                width="364"
                height="416"
              />
            </motion.div>

            <motion.div 
              className="get-started-button-container"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <button 
                className="get-started-btn"
                onClick={() => navigate('/professionals')}
              >
                Get a plan
              </button>
            </motion.div>

            <motion.div 
              className="hero-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
            >
              <h2>Your transformation starts NOW</h2>
            </motion.div>

            {/* Join professionals button disabled */}
            {/*
            <motion.div 
              className="join-professionals-button-container"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.0 }}
            >
              <button 
                className="join-professionals-btn"
                onClick={() => navigate('/professionals')}
              >
                Join Professionals
              </button>
            </motion.div>
            */}
          </div>

          <div className="hero-right">
            <motion.div 
              className="hero-stat"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <span className="stat-text">Best Fitness<br />program for</span>
              <span className="stat-number">2025-2026</span>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
      >
        <div className="scroll-arrow"></div>
        <span className="scroll-hint">Scroll to explore</span>
      </motion.div>
    </section>
  );
};

export default HeroSection;
